// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3660":"0cf0248d","9414":"baf666a0"}[chunkId] + ".chunk.css";
};